import { api } from "@/api";
import { COUNTRY_CODE, IS_TESTING_ENV } from "@/constants";
import { type TFeatureConfigContextState } from "@/contexts/FeatureConfigContext/FeatureConfigContext";
import { CountryCode } from "@/i18n";
import type { IFeatureConfigResponse } from "./types";

export const getLocalFeatureConfig = () =>
  ({
    isAdditionalServicesEnabled: COUNTRY_CODE === CountryCode.LT,
    isAddPayerEnabled: true,
    isExternalProjectEnabled: COUNTRY_CODE === CountryCode.LT,
    isRegistrationAddressRequired: COUNTRY_CODE === CountryCode.LT,
    isTaxCollectorDisplayWithModalEnabled:
      COUNTRY_CODE === CountryCode.LT || COUNTRY_CODE === CountryCode.PL,
    isTaxCollectorCategoryGroupingEnabled: COUNTRY_CODE === CountryCode.LT,
    isTaxCollectorRadioEnabled: COUNTRY_CODE === CountryCode.EE,
    isDueDateEnabled:
      COUNTRY_CODE === CountryCode.EE || COUNTRY_CODE === CountryCode.PL,
    isExpensePlanningEnabled: true,
    isSavingsPlanningEnabled: true,
    isSavedMinutesStatisticsEnabled: COUNTRY_CODE === CountryCode.LT,
    isCustomerStatisticsEnabled: COUNTRY_CODE === CountryCode.LT,
    isBillComparisonEnabled: COUNTRY_CODE === CountryCode.LT,
    isPaperBillDeliveryEnabled: COUNTRY_CODE === CountryCode.LT,
    isBillVariantSelectorEnabled: COUNTRY_CODE !== CountryCode.LT,
    isHouseAddressOptional:
      COUNTRY_CODE === CountryCode.EE || COUNTRY_CODE === CountryCode.PL,
    isOverviewBillComparisonEnabled: COUNTRY_CODE === CountryCode.LT,
    isUtilityStatisticsEnabled: COUNTRY_CODE === CountryCode.LT,
    isNonProfitProvidersEnabled: true,
    isPoaEnabled: COUNTRY_CODE === CountryCode.EE,
    isPaymentStatusAdvertEnabled: false,
    isPaymentStatusBudgetActionEnabled: COUNTRY_CODE === CountryCode.LT,
    isHelpPageShortNumberEnabled: COUNTRY_CODE === CountryCode.LT,
    isJbsSummaryProvidersProgressEnabled: COUNTRY_CODE === CountryCode.LT,
    isBudgetEnabled:
      COUNTRY_CODE === CountryCode.LT || COUNTRY_CODE === CountryCode.EE,
    isProviderFilteringByCategoryEnabled: COUNTRY_CODE === CountryCode.LT,
    isBankConsentLedgerEnabled: COUNTRY_CODE === CountryCode.EE,
    isServiceProviderStatisticsEnabled: true,
    isRequestedServiceProvidersCollapseEnabled: COUNTRY_CODE !== CountryCode.LT,
    isChubbInsuranceEnabled:
      COUNTRY_CODE === CountryCode.PL || COUNTRY_CODE === CountryCode.LT,
    isDefaultPlanDiscountEnabled:
      COUNTRY_CODE === CountryCode.EE || COUNTRY_CODE === CountryCode.PL,
    isBudgetCustomCategoriesEnabled: true,
    isOnboardingEnabled:
      COUNTRY_CODE === CountryCode.PL || COUNTRY_CODE === CountryCode.EE,
    isJointBillServiceDragAndDropEnabled: IS_TESTING_ENV,
    isBudgetIncludeTransfersBetweenAccountsInStatisticsSwitchEnabled: true,
  }) as TFeatureConfigContextState;

export const getFeatureConfig = async () =>
  (await api.get<IFeatureConfigResponse>("/feature-flags")).data;
